import { UPLOAD_POLICIES, UPLOAD_PURPOSE_USER_AVATAR } from "@nexus/contracts";

const USER_AVATAR_POLICY = UPLOAD_POLICIES[UPLOAD_PURPOSE_USER_AVATAR];

export const USER_AVATAR_ACCEPT = USER_AVATAR_POLICY.allowedContentTypes.join(",");

export function getUserAvatarMaxBytes(contentType: string): number | undefined {
  return USER_AVATAR_POLICY.maxSizeBytesByContentType[contentType];
}

export function isAllowedUserAvatarType(contentType: string): boolean {
  return USER_AVATAR_POLICY.allowedContentTypes.includes(contentType);
}
